import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=5152cb23&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"
import style0 from "./excel.vue?vue&type=style&index=0&id=5152cb23&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports